/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import React from 'react';

import { segment as segmentConfig } from '@ibm-watson/shared/modules/ia/util/config';
import { getProductProps } from './segmentProperties';
import SegmentScript from './SegmentScript';
import SegmentTracker from './SegmentTracker';

const Segment = React.memo(() => {
  const haveSegment = segmentConfig && segmentConfig.key && segmentConfig.src;

  if (haveSegment) {
    // Set any cookie overrides to allow segment to run locally during development
    if (segmentConfig.cookies) {
      for (const cookie in segmentConfig.cookies) {
        document.cookie = `${cookie}=${segmentConfig.cookies[cookie]}`;
      }
    }
    const segmentDefaultProperties = getProductProps();

    window._analytics = {
      segment: true,
      segment_key: segmentConfig.key,
      coremetrics: false,
      carbonComponentEvents: false,
      navigationWatcher: false,
      nps: true,
      hotjar: false,
      autoPageView: false,
      commonProperties: segmentDefaultProperties
    };

    // TODO: How much of this is needed here?  I think some of the page: stuff
    // was just used to make some common data available to the old angular
    // segment service.  We'll have other ways to do that.
    window.digitalData = {
      page: {
        category: {
          primaryCategory: 'Tooling (Watson Assistant)'
        },
        pageInfo: {
          productId: getProductProps().productId,
          productTitle: getProductProps().productTitle,
          pageID: 'Loading',
          analytics: {
            category: 'Offering Interface'
          },
          ibm: {
            messaging: {
              settings: {
                pillBounds: {
                  right: 360 // bound the pill movement to 360px from the right, at most
                }
              },
              routing: {
                focusArea: null
              }
            }
          }
        }
      }
    };
  } else {
    return null;
  }

  return (
    <div id="segmentStuff">
      <SegmentScript src={segmentConfig.src} />
      <SegmentTracker />
    </div>
  );
});

Segment.displayName = 'Segment';

export default Segment;
